<script setup lang="ts">
import RegistrationForm from '@/components/auth/register/RegistrationForm.vue';
import AuthLayout from '../layouts/AuthLayout.vue';

definePage({
  name: 'register',
  meta: {
    isPublic: true,
  },
});
</script>

<template>
  <AuthLayout>
    <RegistrationForm />
  </AuthLayout>
</template>
